import React, { Fragment, FunctionComponent } from "react";
import { BLOCK_TYPE } from "app/blocks/block.types";
import Announcements from "blocks/components/Announcements/Announcements";
import Article from "blocks/components/Article/Article";
import BannerContact from "blocks/components/Banners/BannerContact/BannerContact";
import BannerSplitImage from "blocks/components/Banners/BannerSplitImage/BannerSplitImage";
import Downloads from "blocks/components/Downloads/Downloads";
import Entrances from "blocks/components/Entrances/Entrances";
import Hero from "blocks/components/Hero/Hero";
import HeroBackground from "blocks/components/HeroBackground/HeroBackground";
import Image from "blocks/components/Image/Image";
import InstagramGrid from "blocks/components/InstagramGrid/InstagramGrid";
import ProductGrid from "blocks/components/ProductGrid/ProductGrid";
import Spots from "blocks/components/Spots/Spots";
import TextImage from "blocks/components/TextImage/TextImage";
import TextNewsletter from "blocks/components/TextNewsletter/TextNewsletter";
import TextVideo from "blocks/components/TextVideo/TextVideo";
import Video from "blocks/components/Video/Video";
import EmbedHtml from "blocks/components/EmbedHtml/EmbedHtml";
import EmbedIframe from "blocks/components/Embed/EmbedIframe";
import YoutubeShortText from "blocks/components/VideoShortText/VideoShortText";
import YoutubeShorts from "blocks/components/VideoShorts/VideoShorts";
import BannerCurvedMedia from "blocks/components/Banners/BannerCurvedMedia/BannerCurvedMedia";
import TeaserBanner from "blocks/components/Banners/TeaserBanner/TeaserBanner";
import HeroBannerCurved from "blocks/components/Banners/HeroBannerCurved/HeroBannerCurved";
import TextBanner from "blocks/components/Banners/TextBanner/TextBanner";
import Divider from "blocks/components/Divider/Divider";

const HomePageBlock: FunctionComponent<BLOCK_TYPE> = (props) => {
    const renderControl = (props: BLOCK_TYPE): React.ReactElement | null => {
        const { settings, contentUdi, settingsUdi, ...content } = props as any;
        switch (content?._contentType) {
            case "blockBannerContact": {
                return (
                    <BannerContact
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockBannerSplitImage": {
                return (
                    <BannerSplitImage
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockDivider": {
                return (
                    <Divider
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockBannerCurvedMedia": {
                return (
                    <BannerCurvedMedia
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockTeaserBanner": {
                return (
                    <TeaserBanner
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockHeroBannerCurved": {
                return (
                    <HeroBannerCurved
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }

            case "blockHero": {
                return (
                    <Hero
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockHeroBackground": {
                return (
                    <HeroBackground
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockArticle": {
                return (
                    <Article
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockTextImage": {
                return (
                    <TextImage
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockTextBanner": {
                return (
                    <TextBanner
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockTextNewsletter": {
                return (
                    <TextNewsletter
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockTextVideo": {
                return (
                    <TextVideo
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockImage": {
                return (
                    <Image
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockEntrances": {
                return (
                    <Entrances
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockSpots": {
                return (
                    <Spots
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockProductGrid": {
                return (
                    <ProductGrid
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockInstagramGrid": {
                return (
                    <InstagramGrid
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockDownloads": {
                return (
                    <Downloads
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockAnnouncements": {
                return (
                    <Announcements
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockVideo": {
                return (
                    <Video
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockEmbedHtml": {
                return (
                    <EmbedHtml
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockEmbedIframe": {
                return (
                    <EmbedIframe
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockVideoShortText": {
                return (
                    <YoutubeShortText
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            case "blockVideoShorts": {
                return (
                    <YoutubeShorts
                        content={content}
                        settings={settings}
                        contentUdi={contentUdi}
                    />
                );
            }
            default: {
                return null;
            }
        }
    };

    return <Fragment>{renderControl(props)}</Fragment>;
};

export default HomePageBlock;
